// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P66ys","option":"styles_option__XHycl","selected":"styles_selected__1bI3w"};